/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S4_I4Inputs */

const tr_kullanim_s4_i4 = /** @type {(inputs: Kullanim_S4_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform'u yasalara, genel ahlaka ve üçüncü kişi haklarına aykırı amaçlarla kullanmamayı taahhüt edersiniz.`)
};

const en_kullanim_s4_i4 = /** @type {(inputs: Kullanim_S4_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You undertake not to use the Platform for purposes contrary to the law, public morals or the rights of third parties.`)
};

const de_kullanim_s4_i4 = /** @type {(inputs: Kullanim_S4_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie verpflichten sich, die Plattform nicht zu Zwecken zu nutzen, die gegen Gesetze, die guten Sitten oder Rechte Dritter verstoßen.`)
};

const ru_kullanim_s4_i4 = /** @type {(inputs: Kullanim_S4_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы обязуетесь не использовать Платформу в целях, противоречащих закону, общественной морали или правам третьих лиц.`)
};

/**
* | output |
* | --- |
* | "You undertake not to use the Platform for purposes contrary to the law, public morals or the rights of third parties." |
*
* @param {Kullanim_S4_I4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s4_i4 = /** @type {((inputs?: Kullanim_S4_I4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S4_I4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s4_i4(inputs)
	if (locale === "de") return de_kullanim_s4_i4(inputs)
	if (locale === "ru") return ru_kullanim_s4_i4(inputs)
	return tr_kullanim_s4_i4(inputs)
});